import React from 'react'
// import moment from 'moment'
import { DateUtil, TIME } from '@utils'
import { IFile, IAsset } from '@api'
import { Confirmation, Flex, List, Item, FileDrop, IconButton } from '@ui'
import { DATE_FMT } from '@constants'
import { useFileDownload } from '@hooks'
import Link from '@ui/Link'

export default function FileTable({
  fileTypes = { 'image/*': ['.pdf', '.csv', '.doc', '.docx'] },
  editing,
  files,
  localFiles,
  onAdd,
  onRemove,
  containerStyle,
  fileDropHeight,
  maxSize = 11,
}: FileTableProps) {
  return (
    <div style={containerStyle ? containerStyle : { width: '100%', marginTop: 8 }}>
      <List title="File name">
        {!editing && !files.length && <Item>No Files</Item>}
        {localFiles.map((f, i) => (
          <File
            key={`new-${i}`}
            editing={!!editing}
            name={f.name}
            onRemove={onRemove ? () => onRemove(f) : undefined}
          />
        ))}
        {files.map((f, i) => (
          <File
            key={i}
            editing={!!editing}
            name={f.name || f.fileName}
            url={f.url}
            onRemove={onRemove ? () => onRemove(f) : undefined}
            createdAt={f.createdAt}
          />
        ))}
        {editing && (
          <Item>
            <FileDrop accept={fileTypes} onDrop={onAdd} height={fileDropHeight} maxSize={maxSize} />
          </Item>
        )}
      </List>
    </div>
  )
}

interface IFileProps {
  createdAt?: Date
  editing: boolean
  name: string
  url?: string
  onRemove?: () => void
}
function File({ editing, name, onRemove, createdAt, url }: IFileProps) {
  const startFileDownload = useFileDownload()

  return (
    <Item>
      <Flex align="center" justify="space-between">
        <div>
          <div
            style={{
              fontSize: 14,
              maxWidth: 300,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {url && <Link onClick={() => url && startFileDownload(url)}>{name}</Link>}
            {!url && name}
          </div>
          {!!createdAt && (
            <div style={{ fontSize: 12, color: 'var(--grey1)' }}>
              Uploaded {DateUtil(createdAt).format(DATE_FMT)}
            </div>
          )}
        </div>
        {editing && onRemove && (
          <div>
            <Confirmation text="Remove this file?" onConfirm={onRemove}>
              <IconButton minimal iconName="trash" />
            </Confirmation>
          </div>
        )}
      </Flex>
    </Item>
  )
}

interface IAddRemoveCallbacks {
  onAdd: (val: IFile[]) => void
  onRemove?: (val: IAsset | IFile) => void
}
interface FileTableProps extends IAddRemoveCallbacks {
  fileTypes?: { 'image/*': ['.pdf', '.csv', '.doc', '.docx'] | ['.dwg'] }
  editing?: boolean
  files: IAsset[]
  localFiles: IFile[]
  maxSize?: number
  containerStyle?: any
  fileDropHeight?: number
}
